import { httpClient } from '@/api/httpClient';
import {
  mapApiResourceToTreatmentPlanTemplates,
  mapTreatmentPlanTemplateDrafts,
  type TreatmentPlanTemplate,
  type TreatmentPlanTemplateDraft,
  type TreatmentPlanTemplatesApiResource,
} from './treatmentPlanTemplatesApi.types';

export async function fetchTreatmentPlanTemplates(): Promise<TreatmentPlanTemplate[]> {
  const response = await httpClient.get<TreatmentPlanTemplatesApiResource>(
    '/me/workspace/treatment-plan-templates'
  );
  return mapApiResourceToTreatmentPlanTemplates(response.data);
}

export async function replaceTreatmentPlanTemplates(
  templates: TreatmentPlanTemplateDraft[]
): Promise<TreatmentPlanTemplate[]> {
  const response = await httpClient.put<TreatmentPlanTemplatesApiResource>(
    '/me/workspace/treatment-plan-templates',
    mapTreatmentPlanTemplateDrafts(templates)
  );
  return mapApiResourceToTreatmentPlanTemplates(response.data);
}
